import React from "react";
import type { ServiceBlockCategory } from "@modes0/ui-components";
import { Camera, ShieldCheck } from "lucide-react";

export const GENERAL_SERVICE_TERM_1 = "Security";
export const GENERAL_SERVICE_TERM_2 = "Electronic Security";
export const GENERAL_SERVICE_TERM_3 = "Security Services";

export const serviceBlockData: ServiceBlockCategory[] = [
  {
    title: "Electronic Security Systems",
    icon: React.createElement(Camera, { size: 29, strokeWidth: 2.4 }),
    accentColor: "#28aae1",
    accentSoftColor: "rgba(40, 170, 225, 0.18)",
    accentDarkColor: "#15171e",
    services: [
      "CCTV Installation & Maintenance Sydney",
      "Alarm System Installation & Support Sydney",
      "Intercom Systems & Visitor Entry Sydney",
      "Access Control Systems & Keyless Entry Sydney",
      "Automatic Security Gates Sydney",
      "Security System Upgrades and Troubleshooting",
      "Integrated Security for Homes and Businesses",
    ],
    imageUrl: "/images/services/stand-alone-service-points/sas-1.webp",
  },
  {
    title: "Guarding, Patrols & Safety Support",
    icon: React.createElement(ShieldCheck, { size: 29, strokeWidth: 2.4 }),
    accentColor: "#f68e22",
    accentSoftColor: "rgba(246, 142, 34, 0.18)",
    accentDarkColor: "#15171e",
    services: [
      "Licensed Security Guards Sydney",
      "Mobile Patrols and Site Checks Sydney",
      "Security Consultation and Risk Assessments",
      "Fire Alarm System Support Sydney",
      "Data Infrastructure & Security Cabling",
      "Retail, Construction and Commercial Site Security",
      "After-Hours Security Planning and Reporting",
    ],
    imageUrl: "/images/services/stand-alone-service-points/sas-2.webp",
  },
];
